import {Container} from 'react-bootstrap';
import {Outlet, useLocation} from 'react-router-dom';
import Header from "./components/Header";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  const location = useLocation();
  const isOnboardingPage = location.pathname.startsWith('/onboarding/');

  return (
    <>
      {!isOnboardingPage && <Header/>}
      <main className={isOnboardingPage ? '' : 'py-3'}>
     
          <Outlet />
       
      </main>
      <ToastContainer/>
    </>
  )
}

export default App